export default "__VITE_ASSET__Bc5eQmyy__"